<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <disposer-form />
  </v-container>
</template>

<script>
import DisposerForm from './_Form'
export default {
  name: 'AdminMasterDisposerFormNew',
  components: {
    DisposerForm
  },
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: '処分方法一覧', disabled: false, to: '/admin/masters/disposers', exact: true },
        { text: '処分方法追加', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
